import VacancySettings from './VacancySettings.page';

export default VacancySettings;